import axios from 'axios';
import { urlPrefix, activityUrl } from './config.js';
import responseCode from './responseCode';
import store from 'Stores';
import { Message, MessageBox } from 'element-ui';
import common from 'Assets/js/common.js';

axios.defaults.withCredentials = true;

axios.interceptors.request.use(
    (config) => {
        config.requestTime = new Date().getTime();
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 设置拦截器
axios.interceptors.response.use(
    (res) => {
        store.state.apiEnv = res.headers.env;
        let code = '';
        if (res.data && res.data.code == 0) {
            code = 0;
        } else if (res.data.code) {
            code = res.data.code;
        } else {
            code = '-';
        }

        // 前端监控上报
        common.dataReport('reqreport', {
            url: res.config.url,
            method: res.config.method,
            status: res.status ? res.status : '-',
            ret_code: code,
            req_time: new Date().getTime() - res.config.requestTime,
        });
        if (code === '-') {
            return res;
        }
        //未登录去登录
        switch (res.data.code) {
            case responseCode.noLogin:
            case responseCode.loginFail:
                store.state.status.login = false;
                store.state.realUserInfo = {};
                //访问的是活动就跳到活动页面，否则跳tgl首页
                if (store.state.curRouter.meta.isActivity) {
                    location.href = activityUrl;
                } else {
                    // location.href = `${document.location.protocol}//${document.location.hostname}`;
                }
                // alert(res.data.info);
                break;
            case responseCode.noActivity:
                alert('活动不存在');
                location.href = `${document.location.protocol}//${document.location.hostname}`;
                break;
            case responseCode.expiredActivity:
                alert('活动已过期');
                location.href = `${document.location.protocol}//${document.location.hostname}`;
                break;
            case responseCode.noJoin:
                alert('无权参加活动');
                location.href = activityUrl;
                break;

            case responseCode.unknowError:
            case responseCode.paramsError:
            case responseCode.dbError:
            case responseCode.serverError:
            case responseCode.illegalityRequest:
            case responseCode.moreRequest:
                Message.error(res.data.info);
                break;
            case 0:
                break;
            case responseCode.userVerifyNull:
                location.href = `${document.location.protocol}//${document.location.hostname}/original/authentication.shtml`;
                break;
            case responseCode.userVerifyApprove:
                // location.hash = '#/center/personal';
                break;
            case responseCode.userVerifyReject:
                store.state.accountRejectReason = res.data.info;
                // MessageBox.alert('驳回原因:'+res.data.info, '提示', {
                //     confirmButtonText: '确定',
                //     callback: action => {
                //         location.hash = '#/center/set/account';
                //     }
                // });
                break;
            case responseCode.banAccount:
                store.state.banInfo.isBan = true;
                store.state.banInfo.reason = res.data.info;
                break;
            default:
                if (res.config.url === `${urlPrefix}/reward/apply`) {
                    MessageBox.alert(
                        res.data.info ? res.data.info : res.data,
                        '提示',
                        {
                            confirmButtonText: '确定',
                            callback: (action) => {},
                        }
                    );
                } else {
                    Message.error(res.data.info ? res.data.info : res.data);
                }
        }
        return res;
    },
    (err) => {
        if (err.response) {
            let msg = '';
            if (err.response.data && err.response.data.msg) {
                msg = err.response.data.msg;
            }
            switch (err.response.status) {
                case 401: // 返回401
                    Message.error(err.response.data.msg || err.response.data);
                    break;
                case 403: //返回403 表示无权访问
                    debugger;
                    Message.error(err.response.data.msg || err.response.data);
                    break;
                default:
                    Message.error(err.response.data.msg || err.response.data);
            }
        }
        return Promise.reject(err.response);
    }
);
export default axios;
